import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";

export const variantMap = {
  variant: {
    primary: {
      "--background-color": vars.semantic.color.surfaceInverse,
      "--color": vars.semantic.color.textInverse,
    },
    secondary: {
      "--background-color": vars.semantic.color.surfaceSlateSecondary,
      "--color": vars.semantic.color.textSub,
    },
    accent: {
      "--background-color": vars.semantic.color.surfaceHighlightPrimary,
      "--color": vars.semantic.color.text,
    },
    critical: {
      "--background-color": vars.semantic.color.surfaceCriticalPrimary,
      "--color": vars.semantic.color.text,
    },
    "primary-inverse": {
      "--background-color": vars.semantic.color.surface,
      "--color": vars.semantic.color.text,
    },
    "secondary-inverse": {
      "--background-color": vars.semantic.color.surface,
      "--color": vars.semantic.color.textSub,
    },
    "accent-inverse": {
      "--background-color": vars.semantic.color.surface,
      "--color": vars.semantic.color.textAccent,
    },
    "critical-inverse": {
      "--background-color": vars.semantic.color.surface,
      "--color": vars.semantic.color.textCritical,
    },
  } as Record<string, Record<string, string>>,
  size: {
    small: {
      "--padding": `${vars.spacing["1"]} ${vars.spacing["15"]}`,
      "--min-width": "20px",
      // label-xsmall
      "--font-size": vars.fontSize["2xsmall"],
      "--line-height": vars.lineHeight[3],
      "--font-weight": vars.fontWeight.semibold,
    },
    medium: {
      "--padding": `${vars.spacing["05"]} ${vars.spacing["15"]}`,
      "--min-width": "20px",
      // label-small-bold
      "--font-size": vars.fontSize.xsmall,
      "--line-height": vars.lineHeight[4],
      "--font-weight": vars.fontWeight.semibold,
    },
    large: {
      "--padding": `0 ${vars.spacing["15"]}`,
      "--min-width": "24px",
      // label-medium-bold
      "--font-size": vars.fontSize.small,
      "--line-height": vars.lineHeight["6"],
      "--font-weight": vars.fontWeight.semibold,
    },
  } as Record<string, Record<string, string>>,
};

export const numberBadgeCSS = css({
  display: "inline-block",
  verticalAlign: "middle",
  textAlign: "center",

  // variant styles
  backgroundColor: "var(--background-color)",
  color: "var(--color)",

  // size styles
  padding: "var(--padding)",
  minWidth: "var(--min-width)",
  fontSize: "var(--font-size)",
  lineHeight: "var(--line-height)",
  fontWeight: "var(--font-weight)",

  "*:disabled > &": {
    backgroundColor: vars.semantic.color.surfaceSub,
    color: vars.semantic.color.textDisabled,
  },

  borderRadius: vars.rounded.full,
});
